module.exports = __webpack_public_path__ + "img/logo.f7e84200.png";